export default __webpack_public_path__ + "static/media/sitemap.406dde86.svg";